export default __webpack_public_path__ + "static/media/pexels-jeshootscom-13861.790738ba.jpg";